import { Col, Row } from 'antd';
import React from 'react';
import { ASSISTANT, TEACHER } from '@BUP/constants';
import { useAuth } from '@BUP/hooks';
import styles from './data-bup-card.module.css';

const DataBupCard = ({ icon, alt, text }) => {
  const { user } = useAuth();
  const roleType = user?.roles?.type;
  return (
    <Row
      gutter={[24, 10]}
      className={
        roleType === ASSISTANT || roleType === TEACHER
          ? styles.card_wrapper_teacher
          : styles.card_wrapper
      }
    >
      <Col
        span={8}
        className={
          roleType === ASSISTANT || roleType === TEACHER
            ? styles.icon_wrapper_teacher
            : styles.icon_wrapper
        }
      >
        <img className={styles.icon} src={icon} alt={alt} />
      </Col>
      <Col span={16} className={styles.text_wrapper}>
        <h4 className={styles.card_text}>{text}</h4>
      </Col>
    </Row>
  );
};

export default DataBupCard;
